import { Navigate, useParams } from "react-router-dom";

export default function UniversityInternshipsIndexPage() {
  const { universityId } = useParams();
  return <Navigate to={`/education/universities/${universityId}/internships/current`} replace />;
}
